import { useRef, useState, useEffect } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import {
  classNames,
  disabledIfFieldChecker,
  fieldsNotEmptyChecker,
  findDataInFields,
  removeTrailingZerosUntil2,
} from "../../../utils/helperFuctions";
import { useSelector } from "react-redux";
import axios from "axios";
import { config } from "../../../utils/config";
import { getCookie, setCookie } from "../../../utils/cookieHandler";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function InputText({
  label,
  label2,
  name,
  type,
  id,
  placeholder,
  defaultValue,
  err,
  required,
  handleChange,
  disabled,
  dataid,
  dataisnew,
  hide,
  lazyloadUrl,
  lazyloadParam,
  body,
  dataItem,
  lazyloadFieldChange,
  decimalCount,
  minValue,
  maxValue,
  classes,
  forceReloadIcon,
  forceReloadFunction,
  disabledIfField,
  hideComponent,
  step,
  getInitialPriceOnFieldChange,
  display,
  disableWhenFieldsAreFilled,
  converter, // { ratio: number, placeholder?: string, decimal?: number }
  disableEditForNonAdmin,
  formType,
  currentRole,
}) {
  const currentFields = useSelector((state) => state.showFields);
  const [isLoading, setIsLoading] = useState();
  const [value, setValue] = useState(
    defaultValue === null || defaultValue === undefined ? null : defaultValue
  );

  // Converter as one-way calculator: stays empty unless user types in it
  const [convValue, setConvValue] = useState(""); // string shown in converter input

  const [_label2, setLabel2] = useState();
  const [changing, setChanging] = useState(false);
  const [valueLazyloaded, setValueLazyloaded] = useState({
    previousValue: null,
    changed: false,
  });

  // ---- helpers
  const clamp = (num, min, max) => {
    let out = num;
    if (min != null && !Number.isNaN(parseFloat(min)))
      out = Math.max(out, Number(min));
    if (max != null && !Number.isNaN(parseFloat(max)))
      out = Math.min(out, Number(max));
    return out;
  };

  const roundTo = (num, decimals) => {
    if (decimals == null) return num;
    if (decimals === 0) return Math.round(num);
    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  };

  const fmtMain = (n) =>
    changing ? n : removeTrailingZerosUntil2(n, decimalCount);

  // ---- hide logic
  const checkIfIsHidden = () => {
    let isHidden = false;
    if (hideComponent != null && currentFields != null) {
      if (hideComponent.if != null) {
        const statement = findDataInFields(currentFields, hideComponent.if);
        if (statement === hideComponent.equalsTo) {
          isHidden = true;
        }
      }
    }
    return isHidden;
  };
  const isHidden = checkIfIsHidden();

  // wheel prevention on number input
  const inputRef = useRef(null);
  useEffect(() => {
    const input = inputRef.current;
    if (input == null) return;
    const preventScroll = (e) => {
      if (
        input.tagName.toLowerCase() === "input" &&
        input.type === "number" &&
        document.activeElement === input
      ) {
        e.preventDefault();
      }
    };
    input.addEventListener("wheel", preventScroll, { passive: false });
    return () => input.removeEventListener("wheel", preventScroll);
  }, []);

  // keep local value in sync with defaultValue prop (converter stays as-is/empty)
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const getLazyload = async (url, param, toSend) => {
    try {
      if (url) {
        axios
          .post(`${config.apiUrl}/api/${url}`, toSend, {
            headers: { Authorization: `Bearer ${getCookie("_AT")}` },
          })
          .then((d) => {
            if (d.headers?.authorization) {
              if (`Bearer ${getCookie("_AT")}` !== d.headers.authorization) {
                setCookie("_AT", d.headers.authorization.split(" ")[1]);
              }
            }
            if (
              d.data &&
              !Array.isArray(d.data) &&
              d.data[param] !== null &&
              d.data[param] !== undefined &&
              typeof d.data[param] !== "object" &&
              !Array.isArray(d.data[param])
            ) {
              setValue(d.data[param]);
              inputChange({
                target: {
                  name: name,
                  value: d.data[param],
                  dataset: {
                    id: dataid,
                    isnew: dataisnew,
                  },
                },
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fieldChangeValue =
    getInitialPriceOnFieldChange != null
      ? findDataInFields(currentFields, getInitialPriceOnFieldChange.field)
      : undefined;

  useEffect(() => {
    const fetchData = async () => {
      if (
        getInitialPriceOnFieldChange != null &&
        fieldChangeValue === getInitialPriceOnFieldChange.value
      ) {
        setIsLoading(true);
        await forceReloadFunction({
          target: {
            name: name,
            value: value,
            dataset: {
              id: dataid,
              isnew: dataisnew,
            },
          },
        });
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldChangeValue]);

  useEffect(() => {
    if (
      lazyloadUrl &&
      lazyloadParam &&
      body &&
      ((defaultValue === null && value == null) ||
        defaultValue === undefined ||
        defaultValue === "" ||
        defaultValue === "null")
    ) {
      const toSend = {};
      if (body.fromData) {
        for (const key in body.fromData) {
          if (dataItem) toSend[key] = dataItem[body.fromData[key]];
        }
      }
      if (body.fromFields) {
        for (const key in body.fromFields) {
          if (
            body.takeLiteralValueForField != null &&
            body.takeLiteralValueForField.includes(key)
          ) {
            toSend[key] = body.fromFields[key];
            continue;
          }
          if (currentFields != null) {
            toSend[key] = findDataInFields(currentFields, body.fromFields[key]);
          }
        }
      }
      getLazyload(lazyloadUrl, lazyloadParam, toSend);
    }

    if (label2 && currentFields != null) {
      if (label2.includes("<s>")) {
        setLabel2(label2.replace("<s>", ""));
      } else {
        setLabel2(findDataInFields(currentFields, label2));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyloadUrl, lazyloadParam, body, label2]);

  // MAIN input change (does NOT update converter)
  const inputChange = (e) => {
    setChanging(true);
    setConvValue("");
    let rawValue = e.target.value;
    let nextValue;

    if (type === "number") {
      const numericInput = parseFloat(rawValue);
      if (isNaN(numericInput)) {
        nextValue = "";
      } else {
        nextValue = clamp(numericInput, minValue, maxValue);
      }
    } else {
      nextValue = rawValue;
    }

    setValue(nextValue);

    // Do NOT sync converter; it stays as user typed (usually empty)

    const modifiedEvent =
      type === "number"
        ? {
            target: {
              name: name,
              value: nextValue,
              dataset: e.target.dataset,
            },
          }
        : e;

    handleChange(modifiedEvent);
  };

  // Converter onChange → update MAIN input only; converter text remains as typed
  const onConverterChange = (e) => {
    if (!converter) return;
    if (e.target.value < 0) {
      e.target.value = 0;
      setConvValue(0);
      setValue(0);
      handleChange({
        target: {
          name,
          value: 0,
          dataset: {
            id: dataid,
            isnew: dataisnew,
          },
        },
      });
      return;
    }
    const raw = e.target.value;
    setConvValue(raw); // keep what user typed

    if (raw === "") {
      // Clearing converter does not affect main value
      return;
    }

    const n = parseFloat(raw);
    if (Number.isNaN(n)) return;

    if (!converter?.ratio || Number.isNaN(converter.ratio)) return;

    // Compute → Round to converter.decimal → Clamp
    let computedMain = n * converter.ratio;
    computedMain = roundTo(computedMain, converter.decimal ?? 0);
    computedMain = clamp(computedMain, minValue, maxValue);

    setValue(computedMain);

    // Fire parent change as number event
    handleChange({
      target: {
        name,
        value: computedMain,
        dataset: {
          id: dataid,
          isnew: dataisnew,
        },
      },
    });
  };

  const inputModeProps =
    type === "number"
      ? {
          inputMode: "numeric",
          pattern: "[0-9]*[.]?[0-9]*",
          min: minValue,
          max: maxValue,
        }
      : {};

  const reloadClicked = async () => {
    if (isLoading === true) return;
    setChanging(false);
    if (forceReloadIcon) {
      if (forceReloadFunction instanceof Function) {
        setIsLoading(true);
        await forceReloadFunction({
          target: {
            name: name,
            value: value,
            dataset: {
              id: dataid,
              isnew: dataisnew,
            },
          },
        });
        setIsLoading(false);
      }
    } else {
      if (lazyloadUrl && lazyloadParam && body) {
        setIsLoading(true);
        const toSend = {};
        if (body.fromData) {
          for (const key in body.fromData) {
            if (dataItem) {
              toSend[key] = dataItem[body.fromData[key]];
            }
          }
        }
        if (body.fromFields) {
          for (const key in body.fromFields) {
            if (
              body.takeLiteralValueForField != null &&
              body.takeLiteralValueForField.includes(key)
            ) {
              toSend[key] = body.fromFields[key];
            } else if (currentFields) {
              toSend[key] = findDataInFields(
                currentFields,
                body.fromFields[key]
              );
            }
          }
        }
        await getLazyload(lazyloadUrl, lazyloadParam, toSend);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (valueLazyloaded.changed) {
      if (Array.isArray(lazyloadFieldChange) && currentFields) {
        let flag = false;
        let currentValues = valueLazyloaded.previousValue || {};
        for (const i in lazyloadFieldChange) {
          let f = lazyloadFieldChange[i];
          const findRelatedField = currentFields.find(
            (x) => x.name === f && x.changed === true
          );

          if (
            findRelatedField &&
            !Array.isArray(findRelatedField?.defaultValue) &&
            currentValues[f] !== findRelatedField?.defaultValue
          ) {
            currentValues = {
              ...currentValues,
              [f]: findRelatedField.defaultValue,
            };
            flag = true;
          }
        }

        if (flag) {
          setValueLazyloaded({ changed: false, previousValue: currentValues });
          if (lazyloadUrl && lazyloadParam && body) {
            const toSend = {};
            if (body.fromData) {
              for (const key in body.fromData) {
                if (dataItem) {
                  toSend[key] = dataItem[body.fromData[key]];
                }
              }
            }
            if (body.fromFields) {
              for (const key in body.fromFields) {
                if (currentFields) {
                  toSend[key] = findDataInFields(
                    currentFields,
                    body.fromFields[key]
                  );
                }
              }
            }
            getLazyload(lazyloadUrl, lazyloadParam, toSend);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueLazyloaded]);

  useEffect(() => {
    setValueLazyloaded((prev) => {
      return { ...prev, changed: true };
    });
  }, [currentFields]);

  const reloadBtnRef = useRef(null);
  useEffect(() => {
    const reloadClickedFetcher = async () => {
      await forceReloadFunction({
        target: {
          name: name,
          value: value,
          dataset: {
            id: dataid,
            isnew: dataisnew,
          },
        },
      });
    };
    if (
      dataItem != null &&
      dataItem.addonid != null &&
      defaultValue === "null"
    ) {
      reloadClickedFetcher();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFocus = (e) => {
    e.target.addEventListener("wheel", (ev) => ev.preventDefault(), {
      passive: false,
    });
  };

  let isFieldDisabled =
    disableWhenFieldsAreFilled != null
      ? fieldsNotEmptyChecker(currentFields, disableWhenFieldsAreFilled)
      : disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;
  if (
    disableEditForNonAdmin != null &&
    disableEditForNonAdmin === true &&
    currentRole !== process.env.REACT_APP_ADMIN_ROLE &&
    formType === "edit"
  ) {
    isFieldDisabled = true;
  }

  return (
    <>
      {isHidden === true ? (
        <div></div>
      ) : (
        <div className={`${hide ? "hidden" : "relative"} ${classes}`}>
          {display != null && (
            <div className="text-sm font-semibold leading-6 text-gray-400 absolute left-0 top-[-20px]">
              {display.title}
              <span>{findDataInFields(currentFields, display.value)}</span>
            </div>
          )}
          {label && (
            <label
              htmlFor={name}
              className="block text-sm font-medium leading-6 text-gray-900 text-left"
            >
              {label}
              {required ? "*" : ""}
            </label>
          )}

          <div className={`relative ${label ? "mt-2 rounded-md " : ""}`}>
            <div className="flex items-center gap-x-3 relative">
              {_label2 && (
                <span className="text-sm font-semibold leading-6 text-gray-900">
                  {_label2}
                </span>
              )}

              {/* Converter input (one-way calculator; optional) */}
              {converter && (
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    inputMode="numeric"
                    pattern="[0-9]*[.]?[0-9]*"
                    className="w-36 rounded-md border-0 py-1.5 px-2 ring-1 ring-inset ring-blue-300 focus:ring-blue-500 sm:text-sm disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
                    placeholder={converter.placeholder || "Converted"}
                    value={convValue}
                    onChange={onConverterChange}
                    disabled={isFieldDisabled === true || isLoading === true}
                  />
                </div>
              )}

              {/* Main input */}
              <input
                ref={inputRef}
                type={type ?? "text"}
                name={name}
                step={type === "number" ? step : undefined}
                id={id}
                className={classNames(
                  err
                    ? "text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500"
                    : "focus:ring-blue-500 focus:ring-inset",
                  "block w-full rounded-md border-0 py-1.5 pr-10 ring-1 ring-inset ring-blue-300 sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200"
                )}
                placeholder={placeholder}
                aria-invalid="true"
                aria-describedby="email-error"
                onChange={inputChange}
                value={fmtMain(value)}
                disabled={isFieldDisabled === true || isLoading === true}
                data-id={dataid}
                data-isnew={dataisnew}
                onFocus={handleFocus}
                {...(type === "number"
                  ? {
                      inputMode: "numeric",
                      pattern: "[0-9]*[.]?[0-9]*",
                      min: minValue,
                      max: maxValue,
                    }
                  : {})}
              />

              {isLoading === true && (
                <div
                  className="absolute"
                  style={{
                    top: "50%",
                    left: "5%",
                    transform: "translate(-0%,-50%)",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="24"
                    height="24"
                    strokeWidth="2"
                  >
                    <path d="M12 3a9 9 0 1 0 9 9"></path>
                  </svg>
                </div>
              )}

              {(forceReloadIcon || (lazyloadUrl && lazyloadParam && body)) &&
                isFieldDisabled === false && (
                  <button
                    onClick={async () => {
                      if (isLoading === true) return;
                      await reloadClicked();
                    }}
                    type="button"
                    className={`${
                      disabled === true && "hidden"
                    } w-5 absolute right-2 top-2 ml-1 cursor-pointer`}
                  >
                    <ArrowPathIcon />
                  </button>
                )}
            </div>

            {err && (
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                <ExclamationCircleIcon
                  className="h-5 w-5 text-red-500 "
                  aria-hidden="true"
                />
              </div>
            )}
          </div>
          {err && <p className="text-left mt-2 text-sm text-red-600">{err}</p>}
        </div>
      )}
    </>
  );
}
